// src/hooks/usePlaces.js
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPlacesByCategory,
  fetchPlaceDetailsById,
  buildPlacePhotoUrl,
} from "../redux/placesThunks";
import { selectPlace } from "../redux/placesSlice";
import { BASE_URLS } from "../../api/axios";

/** Helper: URL Google Maps directions */
export const getDirectionsUrlFor = (place) => {
  const pid = place?.place_id;
  if (pid) return `https://www.google.com/maps/place/?q=place_id:${pid}`;
  const name = encodeURIComponent(place?.name || "Place");
  const lat = place?.latitude ?? place?.coordinates?.lat ?? 0;
  const lng = place?.longitude ?? place?.coordinates?.lng ?? 0;
  return `https://www.google.com/maps/place/${name}/@${lat},${lng},17z`;
};

/** Helper: image (utilise buildPlacePhotoUrl pour filtrer les URL Google) */
export const getImageSrcFor = (place) => {
  // priorité à image_url en BD (sans proxy ni Google Photo)
  const safe = buildPlacePhotoUrl({ url: place?.image_url });
  return safe || null; // null → le composant mettra son fallback
};

export default function usePlaces() {
  const dispatch = useDispatch();
  const { items, selected, total, limit, skip, status, error } = useSelector(
    (s) => s.places || {}
  );

  const loadCategory = useCallback(
    (category, params = {}) =>
      dispatch(fetchPlacesByCategory({ category, ...params })),
    [dispatch]
  );

  const loadDetails = useCallback(
    (place_id) => {
      if (!place_id) return;
      return dispatch(fetchPlaceDetailsById({ place_id }));
    },
    [dispatch]
  );

  const doSelectPlace = useCallback((p) => dispatch(selectPlace(p)), [dispatch]);

  const getImageSrc = useCallback(getImageSrcFor, []);
  const getDirectionsUrl = useCallback(getDirectionsUrlFor, []);

  return {
    items,
    selected,
    total,
    limit,
    skip,
    loading: status === "loading",
    error,
    // actions
    loadCategory,
    loadDetails,
    selectPlace: doSelectPlace,
    // helpers
    getImageSrc,
    getDirectionsUrl,
  };
}
